import React from 'react';
import parse from 'html-react-parser';
import { randomKey } from '../../core/util';

/**
 * @param {Object} contents - items to parse as modal content
 * @param {Object} styles - css styles to be applied to content
 */
export const renderModalContent = (contents, styles) =>
  contents &&
  contents.map(item => (
    <React.Fragment key={`modal-content-${item.title}-${randomKey}`}>
      <span
        key={`content-title-${randomKey}`}
        data-name={`content-title-${item.title}`}
        className="modal-content-title top-pad">
        {item.title}
      </span>
      {/* account for content with bulleted list */}
      {item.listItems && (
        <ul>
          {item.listItems.map(li => (
            <li key={`content-item-${li}-${randomKey}`}>{li}</li>
          ))}
        </ul>
      )}
      {/* mapped this way to apply padding between each content paragraph */}
      {item.disc.map(d => (
        <p key={`content-para-${d}-${randomKey}`}>{parse(d)}</p>
      ))}
      <style jsx>{styles}</style>
    </React.Fragment>
  ));
